import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import { useSprings, animated } from "@react-spring/web";

const ParticipantSection = () => {
  const items = [
    "Предприниматели, желающие увеличить доходы и развить бизнес.",
    "Руководители, стремящиеся выстроить сильные команды и улучшить процессы.",
    "Специалисты, которые хотят подняться на новый профессиональный уровень.",
    "Лидеры, стремящиеся развить навыки управления и добиться большего.",
    "Профессионалы, ищущие баланс между работой и личной жизнью.",
  ];

  const colors = ["#d6af84", "#c79d9f", "#b98ba7", "#aa77c4", "#8c53e2"];

  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  const springs = useSprings(
    items.length,
    items.map((_, index) => ({
      from: { opacity: 0, transform: "translateX(-30px)" },
      to: inView
        ? { opacity: 1, transform: "translateX(0px)" }
        : { opacity: 0, transform: "translateX(-30px)" },
      delay: index * 900,
      config: { tension: 80, friction: 20 },
    }))
  );

  return (
    <Box
      ref={sectionRef}
      sx={{
        background: "#000",
        color: "#fff",
        py: { xs: 6, md: 8 },
        px: { xs: 3, md: 6 },
        textAlign: "center",
        minHeight: { xs: "auto", md: "80vh" },
        display: "flex",
        flexDirection: "column",
        justifyContent: { xs: "flex-start", md: "center" },
        alignItems: { xs: "stretch", md: "center" },
      }}
    >
      <Box
        sx={{
          maxWidth: "900px",
          mx: "auto",
          mb: { xs: 4, md: 8 },
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            mb: 3,
            lineHeight: 1.3,
            fontSize: {
              xs: "2.1rem",
              md: "3.3rem",
            },
          }}
        >
          Мои клиенты — это люди, которые готовы к изменениям:
        </Typography>
      </Box>
      <Grid
        container
        spacing={4}
        sx={{
          width: "100%",
          maxWidth: "900px",
          justifyContent: { xs: "flex-start", md: "center" },
        }}
      >
        <Grid
          item
          xs={12}
          md={8}
          sx={{
            p: { xs: 0, md: 0 },
            textAlign: { xs: "left", md: "center" },
          }}
        >
          <List>
            {springs.map((style, index) => (
              <animated.div key={index} style={style}>
                <ListItem>
                  <ListItemIcon>
                    <GroupIcon sx={{ color: colors[index] }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={items[index]}
                    primaryTypographyProps={{
                      sx: { lineHeight: "1.5", fontSize: "1rem" },
                    }}
                  />
                </ListItem>
              </animated.div>
            ))}
          </List>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ParticipantSection;
